import "./App.css";
import "./i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { LanguageSwitcher } from "./components/LanguageSwitcher";

import Home from "./pages/Home";
import About from "./pages/About";
import Solutions from "./pages/Solutions";
import UseCases from "./pages/UseCases";
import OurReach from "./pages/OurReach";
import MobileApp from "./pages/MobileApp";
import Industries from "./pages/Industries";
import Contact from "./pages/Contact";
import Order from "./pages/Order";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import PatientDashboard from "./pages/PatientDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import DoctorLogin from "./pages/DoctorLogin";
import DoctorSignup from "./pages/DoctorSignup";
import DoctorDashboard from "./pages/DoctorDashboard";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import EmployerDashboard from "./pages/EmployerDashboard";
import EmployerLogin from "./pages/EmployerLogin";
import AdminPatientDetail from "./pages/AdminPatientDetail";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Toaster
                        position="top-right"
                        richColors
                        toastOptions={{ style: { fontFamily: "Manrope, sans-serif" } }}
                    />
                    <LanguageSwitcher />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/solutions" element={<Solutions />} />
                        <Route path="/use-cases" element={<UseCases />} />
                        <Route path="/our-reach" element={<OurReach />} />
                        <Route path="/mobile-app" element={<MobileApp />} />
                        <Route path="/industries" element={<Industries />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/order" element={<Order />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/signup" element={<Signup />} />
                        <Route path="/doctor/login" element={<DoctorLogin />} />
                        <Route path="/doctor/signup" element={<DoctorSignup />} />
                        <Route path="/employer/login" element={<EmployerLogin />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route
                            path="/doctor"
                            element={
                                <ProtectedRoute role="doctor">
                                    <DoctorDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute role="patient">
                                    <PatientDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute role="admin">
                                    <AdminDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/patients/:id"
                            element={
                                <ProtectedRoute role="admin">
                                    <AdminPatientDetail />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/employer"
                            element={
                                <ProtectedRoute role="employer">
                                    <EmployerDashboard />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
